import { render } from "./learnerSubmission.vue?vue&type=template&id=6785ff28&scoped=true"
import script from "./learnerSubmission.vue?vue&type=script&lang=js"
export * from "./learnerSubmission.vue?vue&type=script&lang=js"

import "./learnerSubmission.vue?vue&type=style&index=0&id=6785ff28&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6785ff28"]])

export default __exports__